module.exports = __webpack_public_path__ + "static/media/Group_541.88ed6d5e.png";